import { randomNumber } from './randomNumber';

// Generate a valid `id` attribute value that only contains latin characters and dashes.
export function generateIdFromString(
  str: string,
  opts = { addRandomSuffix: false, maxLength: 255 },
) {
  let safeId = str
    .normalize('NFKD') // Convert string to normalized string.  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
    .replace(/\p{Diacritic}/gu, '') // Convert non latin characters to latin characters. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape
    .toLowerCase() // Convert to lowercase
    .replace(/[^\w\s-]/g, '') // Remove non-word characters, keeping letters, numbers, underscores, spaces, and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/^-+|-+$/g, ''); // Trim leading and trailing hyphens

  // Ensure the ID starts with a letter (prefix with "id-" if not)
  if (!/^[A-Za-z]/.test(safeId)) {
    safeId = 'id-' + safeId;
  }

  safeId ||= `id-${crypto.randomUUID().replace(/-/g, '')}`; // Fallback if string is empty after cleaning

  // Ensure the ID does not exceed the maximum length
  if (safeId.length > opts.maxLength) {
    // If `addRandomSuffix` is true, then remove an extra 11 characters to allow room for the random suffix.
    const maxLength = opts.addRandomSuffix ? opts.maxLength - 11 : opts.maxLength;
    safeId = safeId.substring(0, maxLength);
  }

  if (opts.addRandomSuffix) {
    safeId += `-${randomNumber()}`;
  }
  return safeId;
}
